module.exports = __webpack_public_path__ + "static/media/MY.ce611e06.png";